export default "__VITE_ASSET__38fe3274__"